import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getFethSize = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `system-settings`);
};
export const addFethSize = (configData: ConfigurationType) => {
  console.log('configData: ', configData);
  return axios.post(
    GetBackendUrlForGlobalFunctions() + `system-settings`,
    configData,
    {}
  );
};
export const updateFethSize = (configData: ConfigurationType) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `system-settings`,
    configData,
    {}
  );
};

export const deleteFethSize = (configData: ConfigurationType) => {
  return axios.delete(GetBackendUrlForGlobalFunctions() + `system-settings`, {
    data: configData,
  });
};

interface ConfigurationType {
  fetch_size: number;
  id: number;
  isChecked: boolean;
}
